export default __webpack_public_path__ + "static/media/char0.8bdc1b40.svg";